import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheDragonsBreath from "./sections/TheDragonsBreath";
import SelectedVentures from "./sections/SelectedVentures";
import OurExpertise from "./sections/OurExpertise";
import MasteringTheArtOfHardscape from "./sections/MasteringTheArtOfHardscape";
import VoicesOfTheVine from "./sections/VoicesOfTheVine";
import VamosExpandirSeusNegocios from "./sections/VamosExpandirSeusNegocios";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <MasteringTheArtOfHardscape />
      <TheDragonsBreath />
      <SelectedVentures />
      <OurExpertise />
      <VoicesOfTheVine />
      <VamosExpandirSeusNegocios />
      <Footer />
    </div>;
}